import { useTranslation } from 'react-i18next';
import Image from '~/components/Image';
import LayoutSkeleton from '~/components/LayoutSkeleton';
import PreviewCard from '~/components/PreviewCard';
import { LabelTypesEnum } from '~myAccount/enums';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { LabelType } from '~/modules/myAccount/pages/CompanyInfo/types';
import PageLayout from '~myAccount/components/PageLayout';
import { useFullRoutes } from '~/hooks';

const CompanyInfo = () => {
  const { t } = useTranslation('app');
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const { data: response, isLoading, isSuccess } = useGetUserQuery();

  const Bio = response?.user.bio;
  const companyLogo = response?.user.logo?.thumbnails.large as string;

  const labels: LabelType[] = [
    {
      href: MY_ACCOUNT_URL.UPDATE_COMPANY,
      labelType: LabelTypesEnum.COMPANY_LOGO,
    },
    {
      title: t('companyDescription'),
      description: Bio ?? t('unAvailable'),
      labelType: LabelTypesEnum.COMPANY_DESCRIPTION,
    },
  ];
  const isSubAccount = response?.user?.isSubAccount;

  return (
    <PageLayout
      title={t('companyInfo')}
      bodyClassName="border border-gray rounded-[8px]"
    >
      <div className="flex flex-col py-3x ">
        {isLoading && <LayoutSkeleton />}
        {!isLoading &&
          isSuccess &&
          labels.map((label, index) => (
            <PreviewCard
              isSubAccount={isSubAccount}
              key={index}
              img={
                label.labelType === LabelTypesEnum.COMPANY_LOGO && (
                  <Image imgSrc={companyLogo} />
                )
              }
              {...label}
            />
          ))}
      </div>
    </PageLayout>
  );
};

export default CompanyInfo;
